import React, { memo, useEffect, useState } from 'react';
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { practiceTemplatesList, practiceCategories } from "../../services/pratice_templates";

import { useLocalStorage } from 'usehooks-ts'
import Pagination from "../../components/shared/pagination";
import { PracticeTemplatePreview } from "../../components/variation_content_preview";
import { SortBar, SearchBar } from "../../components/FilterBar";
import FiltersModalButton from "../../components/FiltersModalButton";

export const PracticeTemplateListPage = () => {
  const navigate = useNavigate();

  const add = () => navigate("/club_admin/practice_templates/new");
  const select = (item) => navigate(`/club_admin/practice_templates/${item.id}`);

  return <PracticeTemplateList select={select} add={add}/>
}

export default memo(PracticeTemplateListPage);

export const PracticeTemplateList = ({ select, add }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [categories, setCategories] = useState([])
  const [practices, setPractice] = useState([])
  const [count, setCount] = useState(0);

  const getFilterValue = (param, defaultValue) => searchParams.get(param) || defaultValue;
  const initialFilters = {
    page: Number(getFilterValue("page", 1)),
    per_page: 10,
    owner_type: getFilterValue("owner_type", "club"),
    sort_dir: getFilterValue("sort_dir", 'asc'),
    sort_by: 'title',
    q: getFilterValue("q", ""),
    category_ids: getFilterValue("category_ids", null),
    from_age: getFilterValue("from_age", null),
    to_age: getFilterValue("to_age", null)
  };
  const [filters, setFilters] = useState(initialFilters);
  const { owner_type } = filters;

  const { t } = useTranslation();

  const [viewType] = useLocalStorage('practicesViewType', 'list')

  const updateSearchParams = (newFilters) => {
    const updatedParams = new URLSearchParams(searchParams);
    
    Object.entries(newFilters).forEach(([key, value]) =>
      value ? updatedParams.set(key, value) : updatedParams.delete(key)
    );
  
    setSearchParams(updatedParams);
  };

  const loadData = async () => {
    const { practice_templates, count } = await practiceTemplatesList(filters);
    setPractice(practice_templates);
    setCount(count);
  };

  useEffect(() => {
    updateSearchParams(filters);
    loadData();
  }, [filters])

  useEffect(() => { window.scrollTo({ top: 0, behavior: 'smooth' }) }, [filters?.page]);

  useEffect(() => {
    const loadCategories = async () => {
      const data = await practiceCategories();
      setCategories(data.categories);
    };

    loadCategories();
  }, [])


  return (
    <div className="teams">
      <div className="teams-header">
        <div className="teams-header-text">{t('practice_templates.practice')}</div>
        {add && <button className="button button-add" onClick={add}>{t('practice_templates.add_practice')}</button>}
      </div>
      <div className="team-details-tabs margin-top">
        <div className={`team-details-tabs-option pointer ${owner_type === "club" ? 'active' : ''}`} onClick={() => owner_type !== 'clubs' && setFilters({...filters, owner_type: 'club', page: 1 })}>{t('practice_templates.club')}</div>
        <div className={`team-details-tabs-option pointer ${owner_type === "supercoach" ? 'active' : ''}`} onClick={() =>  owner_type !== 'supercoach' && setFilters({...filters, owner_type: 'supercoach', page: 1 })}>{t('practice_templates.supercoach')}</div>
      </div>
      <div className='filters-bar'>
        <div className='flex1'>
          <SortBar viewTypeName='practicesViewType' onSortChange={(sort_dir) => setFilters({...filters, sort_dir })} direction={filters.sort_dir}/>
          <SearchBar onChange={(q) => {setFilters({...filters, q})}} placeholder={t('practice_templates.placeholder')} value={filters.q}/>
        </div>
        <FiltersModalButton filters={filters} onChange={(params) => setFilters({...filters, page: 1, ...params})} categories={categories}/>
      </div>

      <div className={`library-list-container ${viewType}-view`}>
        {practices.map(item =>
          viewType === 'list'
            ? <PracticeListItem practice={item} key={item.id} select={select}/>
            : <PracticeCardItem practice={item} key={item.id} select={select}/>
        )}
      </div>
      <Pagination filters={filters} count={count} onChange={setFilters}/>


    </div>

  )
};

export const PracticeListItem = ({ practice, select }) => {

  const { t } = useTranslation();
  return (
    <div className="library-item">
      <div className="library-item-preview pointer" onClick={() => { select(practice) }}>
        <PracticeTemplatePreview collection={practice.exercises_practices_attributes}/>
      </div>
      <div className="library-item-info">
        <div className="flex-between1">
          <div className="library-item-info-title pointer" onClick={() => { select(practice) }}>{practice.title}</div>
          <div>
            <span className={`new_label new_label-${practice.published ? 'success' : 'default'}`}>
              {practice.published ? t("common.published") : t("common.draft")}
            </span>
          </div>
        </div>
        <div className="library-item-info-row">
          {practice.exercises_practices_attributes.map(item => item?.title).join(", ")}
        </div>
        <div className="library-item-info-row">
          {t('practice_templates.age')} {practice.minimum_age} - {practice.maximum_age}
        </div>
        <div className="library-item-info-row">
          <div className="tags-container">
            <div className="tags">
              <div className='mr10'>{t('practice_templates.tags')}:</div>
              <button className="button button-category mr10">{t(`practice_templates.categories.${practice.category}`, { defaultValue: practice.category })}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


export const PracticeCardItem = ({ practice , select}) => {

  return (
    <div className="library-item">
      <div className="library-item-preview" onClick={() => { select(practice) }}>
        <PracticeTemplatePreview collection={practice.exercises_practices_attributes} size={350}/>
      </div>
      <div className="library-item-info">
        <h5 className="library-item-info-title" onClick={() => { select(practice) }}>
        {practice.title}
        </h5>
      </div>
    </div>
  )
}

